import React from "react";
import ChecklistEditWithReordering from "./ChecklistEditWithReordering";

const ChecklistEditWithReorderingWrapper = props => {
  // TODO: revisit V2 component later
  // return !getIsScoreBasedRubricEnabled() ? (
  //   <ChecklistEditWithReorderingV2 {...props} />
  // ) : (
  //   <ChecklistEditWithReordering {...props} />
  // );

  return <ChecklistEditWithReordering {...props} />;
};

export default ChecklistEditWithReorderingWrapper;
